import { TRIGGER_RULE_TYPE_TO_MEDIUM } from 'modules/workflowNodeEditors/components/HoldUntilReply/HoldUntilReply.constants';
import { HOLD_UNTIL_REPLY_SWITCH_MEDIUM_MODAL } from 'modules/workflows/constants/modals';
import { TriggerHoldUntilReplyRuleType } from 'modules/workflows/constants/nodes/holdUntilReply';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

type Props = {
  isOpen: boolean;
  triggerRuleType: TriggerHoldUntilReplyRuleType;
  handleDeleteAndSwitch: () => void;
  onClose: () => void;
};

export const content = {
  submitButton: 'Delete and switch',
};

export const HoldUntilReplySwitchMediumModal = ({
  isOpen,
  triggerRuleType,
  handleDeleteAndSwitch,
  onClose,
}: Props) => {
  const messageMedium = TRIGGER_RULE_TYPE_TO_MEDIUM[triggerRuleType];

  return (
    <Modal
      id={HOLD_UNTIL_REPLY_SWITCH_MEDIUM_MODAL}
      isModalOpen={isOpen}
      onClose={onClose}
      variant={MODAL_VARIANTS.WARNING}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>{`Switch to ${messageMedium} replies`}</ModalHeader>
      <ModalBody>
        {`Are you sure you want to switch to using ${messageMedium} replies? Your current replies will be
        discarded.`}
      </ModalBody>
      <ModalFooter>
        <Button autoFocus onClick={handleDeleteAndSwitch} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
          {content.submitButton}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
